import { AxiosResponse } from 'axios'
import { DriveItem } from '@microsoft/microsoft-graph-types'
import { outlookDisplayNewMessageForm } from '../../../helpers/outlookHelper'
import useAxios from '../../../hooks/useAxios'
import { getDownloadUrl } from '../../../helpers/documentHelper'
import { useSettings } from '../../useSettings'

export default function useComposeInvoiceOutlookMessage() {
    const axios = useAxios()
    const { settings } = useSettings()

    return async (
        invoiceId: string,
        recipientEmail: string,
        pdf: DriveItem,
        callback?: (asyncResult?: Office.AsyncResult<void>, error?: Error) => void,
    ) => {
        const message: AxiosResponse<{
            body: string
            subject: string
        }> = await axios.get(`/finance/invoice/${invoiceId}/message`)

        outlookDisplayNewMessageForm(
            {
                toRecipients: (recipientEmail?.split(/[,;]/).map(email => ({
                    displayName: email,
                    emailAddress: email?.trim(),
                })) || []) as Office.EmailAddressDetails[],
                bccRecipients: (settings.invoiceEmailBcc?.map(email => ({
                    displayName: email,
                    emailAddress: email?.trim(),
                })) || []) as Office.EmailAddressDetails[],
                subject: message.data.subject,
                attachments: [
                    {
                        type: 'file',
                        name: pdf.name,
                        url: getDownloadUrl(pdf),
                        isInline: false,
                    },
                ] as Office.MessageFormAttachment[],
                htmlBody: message.data.body,
            },
            callback,
        )
    }
}
